// extracted by mini-css-extract-plugin
module.exports = {"container":"_2tp0gfoNp7rDHAR0LCF5JR","groupsList":"_2ZF3eXqjAaAgRO700Wko_3","item":"wEgbDoyoNEPkuPVDeqCW8","dot":"_3EVPUC21Gqbhx8a4Cznwfo"};